<template>
  <div class="action-plan-painting-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p class="lead">{{ !printing ? 'Definir' : ''}} Detalhes do Serviço de Pintura</p>
          <div v-if="!printing" class="d-flex">
            <router-link
              to="/action-plan/form"
              class="btn btn-success"
            >
              <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
              Voltar ao Plano de Ação
            </router-link>
            <div class="save-button ml-3">
              <button @click="save()" class="btn btn-primary">Definir</button>
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <div class="mt-4 w-50">
            <div class="col-12 col-md-12 break-after">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <custom-select-button
                      :title="'Tipo de serviço'"
                      :options="serviceTypeOptions"
                      v-model="serviceTypeOption"
                    />
                  </div>

                  <div class="form-group">
                    <label>Descrição detalhada do serviço</label>
                    <textarea
                      v-model="serviceDescription"
                      type="text"
                      class="form-control"
                      rows="18"
                      style="height: auto"
                    ></textarea>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>Especificação de cor</label>
                    <input
                      v-model="colorSpecification"
                      type="text"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group">
                    <label>Especificação de tinta</label>
                    <input
                      v-model="inkSpecification"
                      type="text"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group">
                    <label>Preferência por fabricante de tinta?</label>
                    <input
                      v-model="inkManufacturerPreference"
                      type="text"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group">
                    <label>Local de aplicação</label>
                    <input v-model="applicationSite" type="text" class="form-control" />
                  </div>

                  <div class="form-group">
                    <label>Técnica de aplicação</label>
                    <input
                      v-model="applicationTechnique"
                      type="text"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group">
                    <label>Medida (largura) da faixa desejada em solo</label>
                    <InputNumber
                      v-model="desiredGroundTrackWidth"
                      mode="decimal"
                      :min="0"
                      :min-fraction-digits="2"
                      :use-grouping="false"
                      class="w-100"
                    />
                  </div>

                  <div class="form-group">
                    <label>Metragem total linear aproximada</label>
                    <InputNumber
                      v-model="approximatedTotalLinearFootage"
                      mode="decimal"
                      :min="0"
                      :min-fraction-digits="2"
                      :use-grouping="false"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomSelectButton from '@/components/common/CustomSelectButton/CustomSelectButton.vue'
  import { useRoute } from 'vue-router'
  import useSwal from '../../../modules/Swal'
  import InputNumber from 'primevue/inputnumber'

  const serviceTypeOptions = [
    {
      label: 'Pintura equipamento / Estrutura',
      value: 1,
      color: '#4CAF50'
    },
    { label: 'Demarcação de solo', value: 2, color: '#2196F3' },
  ]

  export default {
    setup(props) {
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId || props.riskAnalysisDescriptionId

      const { showSuccessDialog, showErrorDialog } = useSwal()

      return {
        riskAnalysisDescriptionId,
        showSuccessDialog,
        showErrorDialog,
        serviceTypeOptions,
      }
    },
    components: {
      CustomSelectButton,
      InputNumber,
    },
    props: {
      riskAnalysisDescriptionId: {
        type: Number,
        required: false,
      },
      printing: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data() {
      return {
        consultancy: false,

        serviceTypeOption: '',

        serviceDescription: '',
        colorSpecification: '',
        inkSpecification: '',
        inkManufacturerPreference: '',
        applicationSite: '',
        applicationTechnique: '',
        desiredGroundTrackWidth: '',
        approximatedTotalLinearFootage: '',

        loading: false,
      }
    },
    methods: {
      save() {
        let payload = {
          risk_analysis_description_id: this.riskAnalysisDescriptionId,
          painting: {
            needs_consultancy: this.consultancy,
            type: this.serviceTypeOption,
            description: this.serviceDescription,
            color: this.colorSpecification,
            painting: this.inkSpecification,
            manufacturer: this.inkManufacturerPreference,
            location: this.applicationSite,
            technique: this.applicationTechnique,
            width: this.desiredGroundTrackWidth,
            linear_measurement: this.approximatedTotalLinearFootage,
          },
        }
        this.axios
          .post(`/api/action-plan/services/painting`, payload)
          .then(() => this.showSuccessDialog())
          .catch(() => this.showErrorDialog())
      },
      load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/services/${this.riskAnalysisDescriptionId}/painting`,
          )
          .then(({ data }) => {
            const service = data.painting_services[0]

            this.consultancy = data.needs_consultancy
            this.serviceTypeOption = service.type
            this.serviceDescription = service.description
            this.colorSpecification = service.color
            this.inkSpecification = service.painting
            this.inkManufacturerPreference = service.manufacturer
            this.applicationSite = service.location
            this.applicationTechnique = service.technique
            this.desiredGroundTrackWidth = service.width
            this.approximatedTotalLinearFootage = service.linear_measurement
          })
          .catch((error) => {
            console.log({ error })
          })
          .finally(() => (this.loading = false))
      },
    },
    mounted() {
      this.load()
    },
  }
</script>
